import { BrandCode } from '../models/curriculum';

const defaultBrandOrder: BrandCode[] = ['HYFI', 'BSFL', 'ETB', 'TGP', 'YOU'];

export const sortCurriculumBrands = <T extends Record<BrandCode, unknown>>(
  unsortedCurriculum: T,
  sortOrder: BrandCode[] = defaultBrandOrder
): T =>
  Object.fromEntries(
    (Object.entries(unsortedCurriculum) as [BrandCode, unknown][]).sort(([brandCodeA], [brandCodeB]) => {
      const indexA = sortOrder.indexOf(brandCodeA);
      const indexB = sortOrder.indexOf(brandCodeB);

      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    })
  ) as T;
